import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { news } from "@/mocks/news";

const slides = news.slice(0, 4);

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const go = (idx: number) => setCurrent((idx + slides.length) % slides.length);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden rounded-lg bg-secondary-900">
      {slides.map((slide, idx) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            idx === current ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.cover}
            alt={`${slide.title} 焦点资讯配图`}
            title={`${slide.title} 91电影焦点推荐`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/90 via-secondary-950/45 to-secondary-950/20" />
          <div className="absolute inset-0 flex items-end">
            <div className="w-full px-6 md:px-12 pb-10 md:pb-14">
              <span className="inline-block bg-accent-500 text-secondary-950 text-xs font-bold rounded-md px-3 py-1 mb-4">
                {slide.category} · 焦点推荐
              </span>
              <h2 className="font-heading font-extrabold text-background-50 text-2xl md:text-4xl max-w-3xl leading-snug">
                {slide.title}
              </h2>
              <p className="text-background-200/90 text-sm md:text-base mt-3 max-w-2xl line-clamp-2">
                {slide.excerpt}
              </p>
              <Link
                to={`/detail/news/${slide.id}`}
                className="inline-flex items-center gap-2 mt-6 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-md px-5 py-2.5 transition-colors whitespace-nowrap cursor-pointer"
              >
                阅读全文
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={() => go(current - 1)}
        aria-label="上一张"
        className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-secondary-950/50 hover:bg-secondary-950/75 text-background-50 items-center justify-center transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        type="button"
        onClick={() => go(current + 1)}
        aria-label="下一张"
        className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-secondary-950/50 hover:bg-secondary-950/75 text-background-50 items-center justify-center transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>

      <div className="absolute bottom-5 right-6 md:right-12 flex items-center gap-2">
        {slides.map((s, idx) => (
          <button
            key={s.id}
            type="button"
            onClick={() => go(idx)}
            aria-label={`切换到第${idx + 1}张`}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              idx === current ? "w-8 bg-accent-500" : "w-3 bg-background-50/60 hover:bg-background-50"
            }`}
          />
        ))}
      </div>
    </section>
  );
}